<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <p class="title" 
            :class="{'required':data.mustanswer}"
            :style="{
                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                color:bandingstyle.appearancePhone.fontStemColor,
                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
            }"
            
        ><span v-if="showTitleNum == 1">{{data.quesIndex + 1}}、</span>
            <HtmlClickImgEnlarge :content="data.questionsName"/>
        </p>
        <div class="input_box"> 
            <el-radio-group @change="userAnswerChange" v-if="data.questionsTypeId == 100 || data.questionsTypeId == 102" v-model="data.userAnswer" class="option-box">
                <template v-for="info in data.optionList" >
                    <el-radio 
                        class="option" 
                        :key="info.oid" 
                        :label="info.oid"
                        border
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                        }"
                    >
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-radio>
                    <div 
                        :key="`op${info.oid}`"
                        v-if="info.haveInput && data.userAnswer == info.oid"
                        class="other-input">
                        <el-input
                            size="medium"
                            :placeholder="$t('UserAnswer.PleaseEnter')"
                            v-model="info.inputValue"
                            >
                        </el-input>
                        <i v-if="info.format == 7" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                        <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                    </div>
                </template>
            </el-radio-group>
            
            <el-checkbox-group @change="userAnswerChange" v-else-if="data.questionsTypeId == 101" v-model="data.userAnswerArr" class="option-box">
                <template v-for="info in data.optionList" >
                    <el-checkbox 
                        class="option" 
                        :key="info.oid" 
                        :label="info.oid"
                        border
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                        }"
                    >
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-checkbox>
                    <div 
                        v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) != -1"
                        :key="`op${info.oid}`"
                        class="other-input">
                        <el-input
                            size="medium"
                            :placeholder="$t('UserAnswer.PleaseEnter')"
                            v-model="info.inputValue"
                            >
                        </el-input>
                        <i v-if="info.format == 7" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                        <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                    </div>
                </template>
            </el-checkbox-group>
            <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
        </div>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
import IDNumberKeyboard from '@/components/IDNumberKeyboard/index.vue'
export default {
    components: {
        HtmlClickImgEnlarge,
        IDNumberKeyboard
    },
    props: {
        data: {},
        bandingstyle:{},
        showTitleNum:{
            type: Number,
            default: 0
        }
    },
    watch: {
        // 'data':{
        //     handler(newV, oldV) {
        //         console.log(newV)
        //     },
        //     deep: true
        // }  
    },
    data() {
        return {
        }
    },
    created() {
        console.log('data', this.data)
        // console.log(this.data.userAnswerArr)
    },
    methods: {
        userAnswerChange() {
            this.$emit('userAnswerChange', this.data)
        },
        keyboardShowClick(name) {
            const keyboardRef = this.$refs[name];
            if (keyboardRef && keyboardRef.length > 0) {
                keyboardRef[0].keyboardShowClick();
            } else if (keyboardRef) {
                keyboardRef.keyboardShowClick();
            } else {
                console.error('未找到对应的组件实例');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .title{
        margin-bottom: 10px;
        word-break: break-all;
        display: flex;
    }
    .option-box{
        display: flex;
        flex-direction: column;
        // padding-left: 25px;
        .option+.option{
            margin-top: 10px;
        }
        .option{
            display: flex;
            align-items: center;
            
            /deep/.el-radio__label{
                display: flex;
                align-items: center;
            }
            /deep/.el-checkbox__label{
                display: flex;
                align-items: center;
            }
        }
        .other-input{
            position: relative;
            width: 100%;
            margin: 10px 0;
            
            .keyboard{
                position: absolute;    
                top: 8px;
                right: 8px;
                color: #f8a430;
                top: 50%; 
                transform: translateY(-50%);
                padding: 10px;
            }
        }
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
/deep/.el-checkbox__label,
/deep/.el-radio__label{
    font-size: inherit;
    text-decoration: inherit;
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
}
.el-radio.is-bordered,
.el-checkbox.is-bordered{
    padding: 9px 5px 9px 10px;
    height: inherit;
    line-height: 1.3;
}
.el-radio.is-bordered+.el-radio.is-bordered,
.el-checkbox.is-bordered+.el-checkbox.is-bordered{
    margin-left: 0;
}
.el-radio, .el-checkbox{
    margin-right: 0;
}
/deep/.el-tiptap-editor__content{
    line-height: 1.3;
    overflow-x: visible
}
</style>
